export const getCurrentValuesByInitialValues = (
  currentValues,
  initialValues
) => {
  const filterInitialValues = ([key]) => initialValues[key] !== undefined;
  const reduceValues = (acc, [key, value]) => {
    acc[key] = value;
    return acc;
  };

  const valuesByInitialValues = Object.entries(currentValues)
    .filter(filterInitialValues)
    .reduce(reduceValues, {});

  return valuesByInitialValues;
};

export const getAmountCellInputName = (id) => `amount_${id}`;
